const TeaserPresenter = (function () {
  function nullTeaser() {
    return {
      title: '',
      subtitle: '',
      content: '',
      urlName: '',
      imageUrl: '/assets/qb-logo-teaser.png',
      imageAlt: ''
    };
  }

  function urlName(publicUrl) {
    return publicUrl === undefined || publicUrl === '' ? '#' : publicUrl;
  }

  function imgUrl(imgPath) {
    const i = imgPath === undefined || imgPath === '';
    return i ? '/assets/qb-logo-teaser.png' : imgPath;
  }

  function getTeaser(data) {
    return {
      title: data.title,
      subtitle: data['consultant.function'],
      content: data.teaser,
      urlName: urlName(data.public_url),
      imageUrl: imgUrl(data.image_rechts_mobil_oben_teaser),
      imageAlt: data.image_alt_rechts_mobil_oben
    };
  }

  return {
    nullTeaser,
    getTeaser
  };
}());

export default TeaserPresenter;



// WEBPACK FOOTER //
// ./teaserPresenter.js